import { createSlice } from '@reduxjs/toolkit'
import { Status } from 'state/interfaces'

enum ICompetitionModals {
  REFERRAL_AND_RULES = 'REFERRAL_AND_RULES',
}

interface CompetitionState {
  showInfoAfter: number
  registrationStarted: {
    [account: string]: boolean
  }
  rulesAccepted: {
    [account: string]: boolean
  }
  refCode: {
    [account: string]: number
  }
  showedDrive: boolean
  twitter: Record<
    string, // account address
    {
      isTwitterBound: boolean
      username?: string // twitter username
      status: Status
    }
  >
  // twitter: {
  //   isTwitterBound: boolean
  //   status: FetchStatus
  // }
  modals: {
    [key in ICompetitionModals]: {
      isOpen: boolean
      data: {
        isRules: boolean
      }
    }
  }
}

const initialState: CompetitionState = {
  showInfoAfter: 0,
  registrationStarted: {},
  rulesAccepted: {},
  refCode: {},
  showedDrive: false,
  twitter: {},
  modals: {
    [ICompetitionModals.REFERRAL_AND_RULES]: {
      isOpen: false,
      data: {
        isRules: false,
      },
    },
  },
}

const competitionSlice = createSlice({
  name: 'competition',
  initialState,
  reducers: {
    updateShowInfo(state, { payload: { timestamp } }) {
      state.showInfoAfter = timestamp
    },
    updateRulesAccepted(state, { payload: { account, rulesAccepted } }) {
      if (!state.rulesAccepted) {
        state.rulesAccepted = {}
      }
      state.rulesAccepted[account] = rulesAccepted
    },
    updateShowedDrive(state) {
      state.showedDrive = true
    },
    updateReferral(state, { payload: { account, refCode } }: { payload: { account: string; refCode: number } }) {
      state.refCode = { ...state.refCode, [account]: refCode }
    },
    updateRegistration(state, { payload: { account } }) {
      state.registrationStarted[account] = true
    },
    updateReferralModal(
      state,
      { payload: { isOpen, data } }: { payload: { isOpen: boolean; data: { isRules: boolean } } }
    ) {
      if (!state.modals) {
        state.modals = {
          [ICompetitionModals.REFERRAL_AND_RULES]: {
            isOpen: false,
            data: {
              isRules: false,
            },
          },
        }
      }
      state.modals.REFERRAL_AND_RULES.isOpen = isOpen
      state.modals.REFERRAL_AND_RULES.data = data
    },
    updateTwitterBind(
      state,
      {
        payload: { isBound, status, account, username },
      }: { payload: { isBound: boolean; status: Status; account: string; username?: string } }
    ) {
      if (!state.twitter) {
        state.twitter = {}
      }
      let _username = username
      if (state.twitter[account] && !username) {
        _username = state.twitter[account].username
      }
      state.twitter[account] = {
        isTwitterBound: isBound,
        status,
        username: _username,
      }

      // state.twitter[account].isTwitterBound = isBound
      // state.twitter[account].status = status
      // if (username) {
      //   state.twitter[account].username = username
      // }
    },
  },
  extraReducers: (builder) => {
    // builder.addCase(updateVersion, (state) => {
    // })
  },
})

export const {
  updateShowInfo,
  updateRulesAccepted,
  updateReferral,
  updateShowedDrive,
  updateTwitterBind,
  updateReferralModal,
  updateRegistration,
} = competitionSlice.actions
export default competitionSlice.reducer
